<template>
  <select
    :id="id"
    :name="name"
    v-model="value"
    @focus="event => emit('focus', event)"
    @blur="event => emit('blur', event)"
  >
    <slot name="select" :options="options"></slot>
  </select>
</template>

<script setup>
import { watch, computed } from 'vue';
import { useStore } from 'vuex';
import { useField } from 'vee-validate';
const store = useStore();

const props = defineProps({
  id: { type: String, require: false },
  name: { type: String, require: true },
  options: { type: [Object, Array], required: true },
  validator: { type: Object, required: true },
  dispatcher: { type: String, required: true }
});

const emit = defineEmits(['focus', 'blur']);

const initialValue = computed(
  () =>
    store.state[props.name] ||
    (store.state.positionInquiryMail &&
      store.state.positionInquiryMail.formData[props.name])
);
const { value } = useField(props.name, props.validator, {
  validateOnMount: false,
  initialValue: initialValue.value !== undefined ? initialValue.value : null
});

const clearDefault = () => {
  if (!props.options.find(item => item.value === value.value)) {
    value.value = null;
  }
};

watch(value, newValue => store.dispatch(props.dispatcher, newValue));
watch(
  () => props.options,
  () => {
    clearDefault();
  }
);

clearDefault();
</script>
